import * as pdfjsLib from 'pdfjs-dist';
import * as util from './util';

declare interface myWindow extends Window {
    readonly pdfjsLibWorkerSrc: string;
}
declare const window: myWindow;

pdfjsLib.GlobalWorkerOptions.workerSrc = window.pdfjsLibWorkerSrc || '/pdfjs-dist/build/pdf.worker.min.mjs';

export async function Print(pdfs: string[], title?: string, raw: boolean = false) {
    const w = window.open('', '', 'height=816,width=1056');
    if (!w) {
        throw new Error('something stopped the print window from appearing');
    }

    w.document.write(`<html>
    <head>
    <style>
    html,body,img{
        margin:0;
        padding:0;
        width:8.5in;
        height:11in;
    }
    @media print{@page {size: 8.50in 11.00in;}}
    </style>
    </head>
    <body>
    </body>
    </html>`);

    if (title) {
        w.document.title = title;
    }

    const width = w.document.body.getBoundingClientRect().width;
    const height = 11 / 8.5 * width;

    let i = 0;
    const checkLoad = () => {
        if (++i === pdfs.length) {
            w.document.close();

            w.print();
            setTimeout(() => w.close());
        }
    };

    for (const p of pdfs) {
        const loadingTask = pdfjsLib.getDocument(raw ? p : util.DataToBlobURL(p, 'application/pdf'));
        const pdf = await loadingTask.promise;
        const page = await pdf.getPage(1);

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const context = canvas.getContext('2d');
        if (!context) {
            throw new Error('could not get canvas context');
        }

        const scale = width / page.getViewport({ scale: 1 }).width;
        const viewport = page.getViewport({ scale });

        await page.render({
            canvasContext: context,
            viewport,
        }).promise;

        const img = document.createElement('img');
        img.src = canvas.toDataURL();
        img.onload = checkLoad;
        w.document.body.appendChild(img);
    }
}

export async function Render(url: string): Promise<string> {
    const loader = pdfjsLib.getDocument(url);
    const pdf = await loader.promise;
    const page = await pdf.getPage(1);

    const viewport = page.getViewport({ scale: 2 });

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) {
        throw new Error('could not get canvas context');
    }
    canvas.width = viewport.width;
    canvas.height = viewport.height;

    await page.render({
        canvasContext: context,
        viewport,
    }).promise;

    return canvas.toDataURL();
}